import { LegalPage, LegalSection } from './LegalPage';
import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <LegalPage title="Terms of Service" updated="October 10, 2026">
      <LegalSection heading="Acceptance of these terms">
        <p>
          MasterStax (the "site", served at <a href="https://masterstax.app">masterstax.app</a>) is a
          product of MikaLabs
          (<a href="https://mikalabs.org" rel="noopener noreferrer" target="_blank">mikalabs.org</a>) and is
          operated by MikaLabs ("we", "us"). By accessing or using the site, you agree to these Terms of
          Service. If you do not agree, please do not use the site. It is provided for students, by students,
          as an educational resource.
        </p>
      </LegalSection>

      <LegalSection heading="The service">
        <p>
          The site organizes publicly available course materials — links, notes and videos —
          into chapters and sections. We may add, change, hide or remove content at any time without notice.
          Content reflects the curriculum of the administrator's courses and is offered for general
          educational use.
        </p>
      </LegalSection>

      <LegalSection heading="OpenStax attribution and licensing">
        <p>
          Course content on this site is built on OpenStax textbooks (openstax.org), which are distributed
          under the Creative Commons Attribution License (CC BY). This site is <strong>not affiliated with,
          endorsed by, or sponsored by OpenStax, Rice University, or Google</strong>. Where OpenStax material
          appears, attribution and license terms are preserved as required by the license.
        </p>
        <p>
          Third-party resources (Khan Academy, YouTube, Desmos, Wolfram Alpha, etc.) remain subject to their
          own terms. A linked or embedded resource does not imply our endorsement of it.
        </p>
      </LegalSection>

      <LegalSection heading="Accounts and acceptable use">
        <ul style={{ paddingLeft: 20 }}>
          <li>Sign-in with Google is optional and used only for progress syncing and administration.</li>
          <li>You are responsible for keeping your Google account secure.</li>
          <li>
            You agree not to misuse the site: no scraping, reverse-engineering, load attacks, attempts to
            bypass access controls, uploading malware, or submitting fraudulent content. Misuse may result
            in access being blocked and, where required, reports to authorities.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="No warranty">
        <p>
          The site is provided "as is" and "as available" without warranties of any kind, express or implied,
          including accuracy, completeness, fitness for a particular purpose, or uninterrupted operation.
          <strong>We do not guarantee that study materials are correct, current, or sufficient for your
          coursework or exams</strong> — always verify with your instructor and official course materials.
        </p>
      </LegalSection>

      <LegalSection heading="Limitation of liability">
        <p>
          To the maximum extent permitted by law, the operator shall not be liable for any indirect,
          incidental, or consequential damages arising from your use of, or inability to use, the site —
          including any reliance you place on study content for grading decisions.
        </p>
      </LegalSection>

      <LegalSection heading="Advertising">
        <p>
          The site is currently free of advertising. If advertising is later introduced (planned via Google
          AdSense), you may view the Privacy Policy section on cookies. Ads must not affect your ability to
          read content.
        </p>
      </LegalSection>

      <LegalSection heading="Copyright and takedowns">
        <p>
          If you believe content on this site infringes your copyright, please email the administrator with:
          (1) identification of the work, (2) the exact URL where the material appears, (3) your contact
          details, (4) a statement of good-faith belief, and (5) a statement that the information is accurate.
          Send this to <a href="mailto:support@mikalabs.org">support@mikalabs.org</a> and we will respond
          promptly and remove infringing material where appropriate.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to these terms">
        <p>
          We may update these terms; material changes will be announced by updating the "last updated" date
          and, where practical, by a notice on the site. Continued use after changes constitutes acceptance.
        </p>
      </LegalSection>

      <LegalSection heading="Governing law">
        <p>
          These terms are governed by the law of the jurisdiction where the site operator resides, excluding
          conflict-of-law rules. If any provision is unenforceable, the remainder stays in effect.
        </p>
      </LegalSection>

      <LegalSection heading="Questions">
        <p>
          See the <Link to="/privacy">Privacy Policy</Link> for contact details, or reach the administrator
          through your course channels.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
